import { colors } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem, responsiveFontSize, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text } = theme;

export const outOfStock = css`
  display: grid;
  grid-template-columns: ${pxToRem(24)} 1fr;
  ${responsiveFontSize(text.xxs)}
  margin: ${stack(28)};
  padding: ${pxToRem(spacing.sm)};
  background-color: ${colors.neutralLight};
  border-radius: ${pxToRem(10)};
`;

export const outOfStockIcon = css`
  align-self: start;
`;

export const outOfStockLabel = css`
  ${responsiveFontSize(text.xs)}
  margin: 0 0 0 ${pxToRem(12)};
`;
